module.exports = __webpack_public_path__ + "static/media/耐火.02d9d385.svg";